import {
  getRoles,
  createRole,
  updateRole,
  deleteRole,
} from '../../shared/services/apiService';

// ── Load all roles ────────────────────────────────────────────────────────────
export const loadRoles = async () => {
  const res = await getRoles();
  return res.data.data.roles;
};

// ── Save (create or update) a role ───────────────────────────────────────────
export const saveRole = async (formData, editId) => {
  if (editId) {
    await updateRole(editId, formData);
    return 'updated';
  }
  await createRole(formData);
  return 'created';
};

// ── Delete role permanently ───────────────────────────────────────────────────
export const removeRole = async (id) => {
  await deleteRole(id);
};
